import { useMemo } from 'react'
import { localStorageKey, useLocalStorage } from 'hooks/useLocalStorageState'
import { CABANA_SETTINGS, Venue } from 'utils/cabanaConfig'

export type { Venue }

export type VenueFilter = {
  [key: string]: boolean
}

const DEFAULT_VENUE_FILTER: VenueFilter = CABANA_SETTINGS.available_venues.reduce(
  (acc, venue) => {
    acc[venue.id] = true
    return acc
  },
  {} as VenueFilter,
)

export function useVenueFilter() {
  return useLocalStorage(
    localStorageKey('tradeVenueFilter-0.5', DEFAULT_VENUE_FILTER),
  )
}

export default function useTrafficSettings() {
  const settings = CABANA_SETTINGS
  const defaultVenueFilter = useMemo(() => DEFAULT_VENUE_FILTER, [])
  return { settings, defaultVenueFilter }
}
